export default function ({ $auth, redirect, route }) {
    let user = $auth.user
    if (!user || !user.school) {
        if (!(route.name === "schule-slug" && user?.business)) {
            redirect("/")
        }
    }
}
